import React from 'react';
import PropTypes from 'prop-types';

import { variableStatsType, variableTypeValues } from '../../constants/types';
import RelativeVariableSummary from '../VariableSummary/RelativeVariableSummary';
import AbsoluteVariableSummary from '../VariableSummary/AbsoluteVariableSummary';

const VariableSummaryChart = ({
  stats, lang, translate, showStandardDeviation, label
}) => {
  switch (stats.type) {
    case variableTypeValues.RELATIVE:
      return (
        <RelativeVariableSummary
          translate={translate}
          lang={lang}
          stats={stats}
          showStandardDeviation={showStandardDeviation}
          label={label}
        />
      );
    case variableTypeValues.ABSOLUTE:
      return (
        <AbsoluteVariableSummary
          translate={translate}
          lang={lang}
          stats={stats}
          showStandardDeviation={showStandardDeviation}
          label={label}
        />
      );
    default:
      return null;
  }
};

const { func, string, bool } = PropTypes;

VariableSummaryChart.propTypes = {
  translate: func.isRequired,
  lang: string.isRequired,
  stats: variableStatsType.isRequired,
  showStandardDeviation: bool.isRequired,
  label: string.isRequired
};

export default VariableSummaryChart;
